// Deskwell — product-deskwell.js | vanilla JS, sin dependencias
(function () {
  var mainBtn = document.getElementById('dw-atc-btn');
  var stickyBar = document.getElementById('dw-sticky-atc');
  var stickyBtn = document.getElementById('dw-sticky-atc-btn');
  var form = document.getElementById('dw-product-form');

  // Mostrar la barra sticky solo cuando el botón principal sale de vista
  if (mainBtn && stickyBar && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          stickyBar.classList.remove('dw-visible');
        } else {
          stickyBar.classList.add('dw-visible');
        }
      });
    }, { threshold: 0 });
    observer.observe(mainBtn);
  }

  // El botón sticky dispara el submit del form principal
  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  // Filtro de reseñas por tag
  var filterButtons = document.querySelectorAll('.dw-filter-tag');
  var reviewsList = document.getElementById('dw-reviews-list');
  if (filterButtons.length && reviewsList) {
    filterButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-tag');
        var isActive = btn.classList.contains('dw-active');

        filterButtons.forEach(function (b) { b.classList.remove('dw-active'); });

        var cards = reviewsList.querySelectorAll('[data-tags]');
        if (isActive) {
          cards.forEach(function (c) { c.style.display = ''; });
          return;
        }

        btn.classList.add('dw-active');
        cards.forEach(function (c) {
          var tags = (c.getAttribute('data-tags') || '').split(',');
          c.style.display = tags.indexOf(tag) !== -1 ? '' : 'none';
        });
      });
    });
  }

  // Puntos de paginación: se resalta el punto según la foto visible
  var gallery = document.getElementById('dw-gallery');
  var dots = document.querySelectorAll('.dw-pdp-dot');
  if (gallery && dots.length && 'IntersectionObserver' in window) {
    var slides = gallery.querySelectorAll('.dw-pdp-slide');
    var dotObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (d) { d.classList.remove('dw-dot-active'); });
          if (dots[idx]) dots[idx].classList.add('dw-dot-active');
        }
      });
    }, { root: gallery, threshold: 0.6 });
    slides.forEach(function (slide) { dotObserver.observe(slide); });
  }

  // ===================================================================
  // Selector de Color + Formato: actualiza variante, precio e imagen
  // ===================================================================
  var dataEl = document.getElementById('dw-variants-data');
  if (!dataEl) return;

  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var variantIdInput = document.getElementById('dw-variant-id');
  var priceWasEl = document.getElementById('dw-price-was');
  var priceNowEl = document.getElementById('dw-price-now');
  var savingsEl = document.getElementById('dw-price-savings');
  var stickyPriceEl = document.getElementById('dw-sticky-price');
  var mainImgEl = document.getElementById('dw-gallery-main-img');

  var colorInputs = document.querySelectorAll('input[name="dw-color-option"]');
  var formatInputs = document.querySelectorAll('input[name="dw-format-option"]');

  function getChecked(inputs) {
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked) return inputs[i].value;
    }
    return inputs.length ? inputs[0].value : null;
  }

  function findVariant(color, format) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var colorOk = !colorInputs.length || v.option1 === color;
      var formatOk = !formatInputs.length || v.option2 === format;
      if (colorOk && formatOk) return v;
    }
    return null;
  }

  function applyVariant(variant) {
    if (!variant) return;

    if (variantIdInput) variantIdInput.value = variant.id;

    if (priceNowEl) priceNowEl.textContent = variant.priceNow;
    if (stickyPriceEl) stickyPriceEl.textContent = variant.priceNow;

    if (priceWasEl) {
      if (variant.priceWas) {
        priceWasEl.textContent = variant.priceWas;
        priceWasEl.style.display = '';
      } else {
        priceWasEl.style.display = 'none';
      }
    }

    if (savingsEl) {
      if (variant.savings) {
        savingsEl.textContent = 'Ahorras ' + variant.savings;
        savingsEl.style.display = '';
      } else {
        savingsEl.style.display = 'none';
      }
    }

    if (mainImgEl && variant.image) {
      mainImgEl.src = variant.image;
      if (gallery) gallery.scrollTo({ left: 0, behavior: 'smooth' });
    }

    if (mainBtn) {
      if (variant.available) {
        mainBtn.disabled = false;
        mainBtn.textContent = 'Añadir al carrito · 30 días de garantía';
      } else {
        mainBtn.disabled = true;
        mainBtn.textContent = 'Agotado';
      }
    }
  }

  function onOptionChange() {
    var color = getChecked(colorInputs);
    var format = getChecked(formatInputs);
    var variant = findVariant(color, format);
    applyVariant(variant);
  }

  colorInputs.forEach(function (input) {
    input.addEventListener('change', onOptionChange);
  });
  formatInputs.forEach(function (input) {
    input.addEventListener('change', onOptionChange);
  });

})();
